import MaterialGrid from "../../../../../__snowpack__/pkg/@mui/material/Grid.js";
import React from "react";
import {SkeletonContainer} from "./merge-units-edit-page-skeleton.styles.js";
function MergeUnitsEditPageSkeleton() {
  return /* @__PURE__ */ React.createElement(MaterialGrid, {
    container: true,
    spacing: 1,
    width: 1
  }, /* @__PURE__ */ React.createElement(MaterialGrid, {
    item: true,
    container: true,
    spacing: 2,
    marginBottom: 4
  }, /* @__PURE__ */ React.createElement(MaterialGrid, {
    item: true,
    xs: 12
  }, /* @__PURE__ */ React.createElement(SkeletonContainer, {
    variant: "rectangular",
    width: 500,
    height: 24
  })), /* @__PURE__ */ React.createElement(MaterialGrid, {
    item: true,
    container: true,
    spacing: 2
  }, /* @__PURE__ */ React.createElement(MaterialGrid, {
    item: true
  }, /* @__PURE__ */ React.createElement(SkeletonContainer, {
    variant: "rectangular",
    width: 100,
    height: 36
  })), /* @__PURE__ */ React.createElement(MaterialGrid, {
    item: true
  }, /* @__PURE__ */ React.createElement(SkeletonContainer, {
    variant: "rectangular",
    width: 200,
    height: 36
  })))), /* @__PURE__ */ React.createElement(MaterialGrid, {
    item: true,
    container: true,
    spacing: 2
  }, /* @__PURE__ */ React.createElement(MaterialGrid, {
    item: true,
    container: true,
    spacing: 2,
    marginBottom: 2
  }, /* @__PURE__ */ React.createElement(MaterialGrid, {
    item: true,
    container: true,
    spacing: 2,
    xs: 4
  }, /* @__PURE__ */ React.createElement(MaterialGrid, {
    item: true,
    container: true
  }, /* @__PURE__ */ React.createElement(SkeletonContainer, {
    variant: "rectangular",
    width: "100%",
    height: 32
  })), /* @__PURE__ */ React.createElement(MaterialGrid, {
    item: true,
    container: true
  }, /* @__PURE__ */ React.createElement(SkeletonContainer, {
    variant: "rectangular",
    width: "100%",
    height: 400
  }))), /* @__PURE__ */ React.createElement(MaterialGrid, {
    item: true,
    container: true,
    spacing: 2,
    xs: 4
  }, /* @__PURE__ */ React.createElement(MaterialGrid, {
    item: true,
    container: true
  }, /* @__PURE__ */ React.createElement(SkeletonContainer, {
    variant: "rectangular",
    width: "100%",
    height: 32
  })), /* @__PURE__ */ React.createElement(MaterialGrid, {
    item: true,
    container: true
  }, /* @__PURE__ */ React.createElement(SkeletonContainer, {
    variant: "rectangular",
    width: "100%",
    height: 400
  }))), /* @__PURE__ */ React.createElement(MaterialGrid, {
    item: true,
    container: true,
    spacing: 2,
    xs: 4
  }, /* @__PURE__ */ React.createElement(MaterialGrid, {
    item: true,
    container: true
  }, /* @__PURE__ */ React.createElement(SkeletonContainer, {
    variant: "rectangular",
    width: "100%",
    height: 32
  })), /* @__PURE__ */ React.createElement(MaterialGrid, {
    item: true,
    container: true
  }, /* @__PURE__ */ React.createElement(SkeletonContainer, {
    variant: "rectangular",
    width: "100%",
    height: 400
  })))), /* @__PURE__ */ React.createElement(MaterialGrid, {
    item: true,
    container: true,
    spacing: 2,
    marginBottom: 2
  }, /* @__PURE__ */ React.createElement(MaterialGrid, {
    item: true,
    xs: 12
  }, /* @__PURE__ */ React.createElement(SkeletonContainer, {
    variant: "rectangular",
    width: 200,
    height: 32
  })), /* @__PURE__ */ React.createElement(MaterialGrid, {
    item: true,
    xs: 12
  }, /* @__PURE__ */ React.createElement(SkeletonContainer, {
    variant: "rectangular",
    height: 200
  }))), /* @__PURE__ */ React.createElement(MaterialGrid, {
    item: true,
    container: true,
    spacing: 2,
    marginBottom: 2
  }, /* @__PURE__ */ React.createElement(MaterialGrid, {
    item: true,
    xs: 12
  }, /* @__PURE__ */ React.createElement(SkeletonContainer, {
    variant: "rectangular",
    width: 200,
    height: 32
  })), /* @__PURE__ */ React.createElement(MaterialGrid, {
    item: true,
    xs: 12
  }, /* @__PURE__ */ React.createElement(SkeletonContainer, {
    variant: "rectangular",
    height: 200
  })))));
}
export default /* @__PURE__ */ React.memo(MergeUnitsEditPageSkeleton);
